import { AdminChromePageTitleBar as KaiShikiAdminChromePageTitleBar } from '@kaiizen/kai-shiki/react';
import type { ReactNode } from 'react';

/**
 * Renovator's page title bar. The one real adaptation left from the old `Client/KaiShiki`
 * seam: it narrows kai-shiki's surface to the props renovator passes, and calls the title
 * click what renovator means by it - going back (KAIDEV-4398).
 */
export const AdminChromePageTitleBar = ({
  title,
  titleIcons,
  headerButtons,
  onBack,
  orgLabel,
  notifications,
  syncStatus,
  profile,
}: {
  title: string;
  titleIcons?: ReactNode[];
  headerButtons?: ReactNode;
  onBack?: () => void;
  orgLabel?: ReactNode;
  notifications?: ReactNode;
  syncStatus?: ReactNode;
  profile?: ReactNode;
}) => (
  <KaiShikiAdminChromePageTitleBar
    title={title}
    titleIcons={titleIcons}
    headerButtons={headerButtons}
    onTitleClick={onBack}
    orgLabel={orgLabel}
    notifications={notifications}
    syncStatus={syncStatus}
    profile={profile}
  />
);
